<template>
  <div v-loading="loading" class="update-button">
    <i @click="update()" class="el-icon-refresh-right"></i>
  </div>
</template>

<script>
export default {
  name: 'UpdateButton',
  props: {
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    rt() {
      return this.$store.getters.rt;
    }
  },
  methods: {
    update() {
      // 
      this.loading = true;

      // 
      this.$store.dispatch("reloadUserData")
        .then((response) => {
          console.log(response);

          // 
          setTimeout(() => {
            this.loading = false;
          }, 3000);
        })
        .catch((error) => {
          console.log(error);

          // 
          this.loading = false;
        });
    }
  }
}
</script>

<style lang="scss" scoped>
.update-button {
  position: fixed;
  right: 5%;
  bottom: 12%;
  width: 50px;
  height: 50px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  border: solid 3px white;
  cursor: pointer;
  border-radius: 5px;

  .el-icon-refresh-right {
    color: #409eff;
  }
}
</style>